import appAxios from "../services/axios";

export const getMagicItems = async () => {
  const response = await appAxios.get("/api/magic-items");
  return response.data;
};

export const postMagicItem = async (itemData) => {
  const response = await appAxios.post("/api/magic-items", itemData);
  return response.data;
};

export const disenchantMagicItem = async (itemId) => {
  const response = await appAxios.delete(
    `/api/magic-items/${itemId}/disenchant`,
  );
  return response.data;
};

export const deleteMagicItem = async (itemId) => {
  const response = await appAxios.delete(`/api/magic-items/${itemId}/trash`);
  return response.data;
};
